import { Fragment as e, jsx as t, jsxs as n } from "react/jsx-runtime";
import * as r from "react";
import i, { Suspense as a, createElement as o, forwardRef as s, useState as c } from "react";
//#region src/lib/components.tsx
function l() {
	return /* @__PURE__ */ t("div", {
		className: "",
		children: /* @__PURE__ */ t("h1", { children: "Welcome to CustodioAiComponents!" })
	});
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@0.513.0_react@19.2.7/node_modules/lucide-react/dist/esm/shared/src/utils.js
var u = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), d = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), f = (e) => {
	let t = d(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, p = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), m = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
}, h = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, g = s(({ color: e = "currentColor", size: t = 24, strokeWidth: n = 2, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: s, ...c }, l) => o("svg", {
	ref: l,
	...h,
	width: t,
	height: t,
	stroke: e,
	strokeWidth: r ? Number(n) * 24 / Number(t) : n,
	className: p("lucide", i),
	...!a && !m(c) && { "aria-hidden": "true" },
	...c
}, [...s.map(([e, t]) => o(e, t)), ...Array.isArray(a) ? a : [a]])), _ = (e, t) => {
	let n = s(({ className: n, ...r }, i) => o(g, {
		ref: i,
		iconNode: t,
		className: p(`lucide-${u(f(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = f(e), n;
}, v = _("arrow-left", [["path", {
	d: "m12 19-7-7 7-7",
	key: "1l729n"
}], ["path", {
	d: "M19 12H5",
	key: "x3x0zl"
}]]), y = _("brain", [
	["path", {
		d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
		key: "l5xja"
	}],
	["path", {
		d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
		key: "ep3f8r"
	}],
	["path", {
		d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4",
		key: "1p4c4q"
	}],
	["path", {
		d: "M17.599 6.5a3 3 0 0 0 .399-1.375",
		key: "tmeiqw"
	}],
	["path", {
		d: "M6.003 5.125A3 3 0 0 0 6.401 6.5",
		key: "105sqy"
	}],
	["path", {
		d: "M3.477 10.896a4 4 0 0 1 .585-.396",
		key: "ql3yin"
	}],
	["path", {
		d: "M19.938 10.5a4 4 0 0 1 .585.396",
		key: "1qfode"
	}],
	["path", {
		d: "M6 18a4 4 0 0 1-1.967-.516",
		key: "2e4loj"
	}],
	["path", {
		d: "M19.967 17.484A4 4 0 0 1 18 18",
		key: "159ez6"
	}]
]), b = _("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), x = _("circle-alert", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["line", {
		x1: "12",
		x2: "12",
		y1: "8",
		y2: "12",
		key: "1pkeuh"
	}],
	["line", {
		x1: "12",
		x2: "12.01",
		y1: "16",
		y2: "16",
		key: "4dfq90"
	}]
]), S = _("circle-check-big", [["path", {
	d: "M21.801 10A10 10 0 1 1 17 3.335",
	key: "yps3ct"
}], ["path", {
	d: "m9 11 3 3L22 4",
	key: "1pflzl"
}]]), C = _("crown", [["path", {
	d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
	key: "1vdc57"
}], ["path", {
	d: "M5 21h14",
	key: "11awu3"
}]]), w = _("loader-circle", [["path", {
	d: "M21 12a9 9 0 1 1-6.219-8.56",
	key: "13zald"
}]]), T = _("refresh-cw", [
	["path", {
		d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
		key: "v9h5vc"
	}],
	["path", {
		d: "M21 3v5h-5",
		key: "1q7to0"
	}],
	["path", {
		d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
		key: "3uifl3"
	}],
	["path", {
		d: "M8 16H3v5",
		key: "1cv678"
	}]
]), ee = _("shield", [["path", {
	d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
	key: "oel41y"
}]]), te = _("star", [["path", {
	d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
	key: "r04s7s"
}]]), ne = _("users", [
	["path", {
		d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
		key: "1yyitq"
	}],
	["path", {
		d: "M16 3.128a4 4 0 0 1 0 7.744",
		key: "16gr8j"
	}],
	["path", {
		d: "M22 21v-2a4 4 0 0 0-3-3.87",
		key: "kshegd"
	}],
	["circle", {
		cx: "9",
		cy: "7",
		r: "4",
		key: "nufk8"
	}]
]), E = _("zap", [["path", {
	d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
	key: "1xq2db"
}]]);
//#endregion
//#region ../../node_modules/.pnpm/react-router@7.17.0_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/react-router/dist/development/chunk-6CSD65Y2.mjs
function D(e, t) {
	if (e === !1 || e == null) throw Error(t);
}
function O(e, t) {
	if (!e) {
		typeof console < "u" && console.warn(t);
		try {
			throw Error(t);
		} catch {}
	}
}
function k({ pathname: e = "/", search: t = "", hash: n = "" }) {
	return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), n && n !== "#" && (e += n.charAt(0) === "#" ? n : "#" + n), e;
}
function A(e) {
	let t = {};
	if (e) {
		let n = e.indexOf("#");
		n >= 0 && (t.hash = e.substring(n), e = e.substring(0, n));
		let r = e.indexOf("?");
		r >= 0 && (t.search = e.substring(r), e = e.substring(0, r)), e && (t.pathname = e);
	}
	return t;
}
function re(e, t, n = "/") {
	return ie(e, t, n, !1);
}
function ie(e, t, n, r, i) {
	let a = M((typeof t == "string" ? A(t) : t).pathname || "/", n);
	if (a == null) return null;
	let o = i ?? oe(e), s = null, c = xe(a);
	for (let e = 0; s == null && e < o.length; ++e) s = ye(o[e], c, r);
	return s;
}
function ae(e, t) {
	let { route: n, pathname: r, params: i } = e;
	return {
		id: n.id,
		pathname: r,
		params: i,
		data: t[n.id],
		loaderData: t[n.id],
		handle: n.handle
	};
}
function oe(e) {
	let t = se(e);
	return le(t), t;
}
function se(e, t = [], n = [], r = "", i = !1) {
	let a = (e, a, o = i, s) => {
		let c = {
			relativePath: s === void 0 ? e.path || "" : s,
			caseSensitive: e.caseSensitive === !0,
			childrenIndex: a,
			route: e
		};
		if (c.relativePath.startsWith("/")) {
			if (!c.relativePath.startsWith(r) && o) return;
			D(c.relativePath.startsWith(r), `Absolute route path "${c.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`), c.relativePath = c.relativePath.slice(r.length);
		}
		let l = P([r, c.relativePath]), u = n.concat(c);
		e.children && e.children.length > 0 && (D(e.index !== !0, `Index routes must not have child routes. Please remove all child routes from route path "${l}".`), se(e.children, t, u, l, o)), !(e.path == null && !e.index) && t.push({
			path: l,
			score: _e(l, e.index),
			routesMeta: u
		});
	};
	return e.forEach((e, t) => {
		if (e.path === "" || !e.path?.includes("?")) a(e, t);
		else for (let n of ce(e.path)) a(e, t, !0, n);
	}), t;
}
function ce(e) {
	let t = e.split("/");
	if (t.length === 0) return [];
	let [n, ...r] = t, i = n.endsWith("?"), a = n.replace(/\?$/, "");
	if (r.length === 0) return i ? [a, ""] : [a];
	let o = ce(r.join("/")), s = [];
	return s.push(...o.map((e) => e === "" ? a : [a, e].join("/"))), i && s.push(...o), s.map((t) => e.startsWith("/") && t === "" ? "/" : t);
}
function le(e) {
	e.sort((e, t) => e.score === t.score ? ve(e.routesMeta.map((e) => e.childrenIndex), t.routesMeta.map((e) => e.childrenIndex)) : t.score - e.score);
}
var ue = /^:[\w-]+$/, de = 3, fe = 2, pe = 1, me = 10, he = -2, ge = (e) => e === "*";
function _e(e, t) {
	let n = e.split("/"), r = n.length;
	return n.some(ge) && (r += he), t && (r += fe), n.filter((e) => !ge(e)).reduce((e, t) => e + (ue.test(t) ? de : t === "" ? pe : me), r);
}
function ve(e, t) {
	return e.length === t.length && e.slice(0, -1).every((e, n) => e === t[n]) ? e[e.length - 1] - t[t.length - 1] : 0;
}
function ye(e, t, n = !1) {
	let { routesMeta: r } = e, i = {}, a = "/", o = [];
	for (let e = 0; e < r.length; ++e) {
		let s = r[e], c = e === r.length - 1, l = a === "/" ? t : t.slice(a.length) || "/", u = j({
			path: s.relativePath,
			caseSensitive: s.caseSensitive,
			end: c
		}, l), d = s.route;
		if (!u && c && n && !r[r.length - 1].route.index && (u = j({
			path: s.relativePath,
			caseSensitive: s.caseSensitive,
			end: !1
		}, l)), !u) return null;
		Object.assign(i, u.params), o.push({
			params: i,
			pathname: P([a, u.pathname]),
			pathnameBase: ke(P([a, u.pathnameBase])),
			route: d
		}), u.pathnameBase !== "/" && (a = P([a, u.pathnameBase]));
	}
	return o;
}
function j(e, t) {
	typeof e == "string" && (e = {
		path: e,
		caseSensitive: !1,
		end: !0
	});
	let [n, r] = be(e.path, e.caseSensitive, e.end), i = t.match(n);
	if (!i) return null;
	let a = i[0], o = a.replace(/(.)\/+$/, "$1"), s = i.slice(1);
	return {
		params: r.reduce((e, { paramName: t, isOptional: n }, r) => {
			if (t === "*") {
				let e = s[r] || "";
				o = a.slice(0, a.length - e.length).replace(/(.)\/+$/, "$1");
			}
			let i = s[r];
			return n && !i ? e[t] = void 0 : e[t] = (i || "").replace(/%2F/g, "/"), e;
		}, {}),
		pathname: a,
		pathnameBase: o,
		pattern: e
	};
}
function be(e, t = !1, n = !0) {
	O(e === "*" || !e.endsWith("*") || e.endsWith("/*"), `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`);
	let r = [], i = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (e, t, n, i, a) => {
		if (r.push({
			paramName: t,
			isOptional: n != null
		}), n) {
			let t = a.charAt(i + e.length);
			return t && t !== "/" ? "/([^\\/]*)" : "(?:/([^\\/]*))?";
		}
		return "/([^\\/]+)";
	}).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
	return e.endsWith("*") ? (r.push({ paramName: "*" }), i += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? i += "\\/*$" : e !== "" && e !== "/" && (i += "(?:(?=\\/|$))"), [new RegExp(i, t ? void 0 : "i"), r];
}
function xe(e) {
	try {
		return e.split("/").map((e) => decodeURIComponent(e).replace(/\//g, "%2F")).join("/");
	} catch (t) {
		return O(!1, `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`), e;
	}
}
function M(e, t) {
	if (t === "/") return e;
	if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
	let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
	return r && r !== "/" ? null : e.slice(n) || "/";
}
var Se = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
function Ce(e, t = "/") {
	let { pathname: n, search: r = "", hash: i = "" } = typeof e == "string" ? A(e) : e, a;
	return n ? (n = Oe(n), a = n.startsWith("/") ? we(n.substring(1), "/") : we(n, t)) : a = t, {
		pathname: a,
		search: Ae(r),
		hash: je(i)
	};
}
function we(e, t) {
	let n = F(t).split("/");
	return e.split("/").forEach((e) => {
		e === ".." ? n.length > 1 && n.pop() : e !== "." && n.push(e);
	}), n.length > 1 ? n.join("/") : "/";
}
function N(e, t, n, r) {
	return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(r)}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function Te(e) {
	return e.filter((e, t) => t === 0 || e.route.path && e.route.path.length > 0);
}
function Ee(e) {
	let t = Te(e);
	return t.map((e, n) => n === t.length - 1 ? e.pathname : e.pathnameBase);
}
function De(e, t, n, r = !1) {
	let i;
	typeof e == "string" ? i = A(e) : (i = { ...e }, D(!i.pathname || !i.pathname.includes("?"), N("?", "pathname", "search", i)), D(!i.pathname || !i.pathname.includes("#"), N("#", "pathname", "hash", i)), D(!i.search || !i.search.includes("#"), N("#", "search", "hash", i)));
	let a = e === "" || i.pathname === "", o = a ? "/" : i.pathname, s;
	if (o == null) s = n;
	else {
		let e = t.length - 1;
		if (!r && o.startsWith("..")) {
			let t = o.split("/");
			for (; t[0] === "..";) t.shift(), --e;
			i.pathname = t.join("/");
		}
		s = e >= 0 ? t[e] : "/";
	}
	let c = Ce(i, s), l = o && o !== "/" && o.endsWith("/"), u = (a || o === ".") && n.endsWith("/");
	return !c.pathname.endsWith("/") && (l || u) && (c.pathname += "/"), c;
}
var Oe = (e) => e.replace(/\/\/+/g, "/"), P = (e) => Oe(e.join("/")), F = (e) => e.replace(/\/+$/, ""), ke = (e) => F(e).replace(/^\/*/, "/"), Ae = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, je = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, Me = class {
	constructor(e, t, n, r = !1) {
		this.status = e, this.statusText = t || "", this.internal = r, n instanceof Error ? (this.data = n.toString(), this.error = n) : this.data = n;
	}
};
function Ne(e) {
	return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
function Pe(e) {
	return P(e.map((e) => e.route.path).filter(Boolean)) || "/";
}
var Fe = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0;
function Ie(e, t) {
	let n = e;
	if (typeof n != "string" || !Se.test(n)) return {
		absoluteURL: void 0,
		isExternal: !1,
		to: n
	};
	let r = n, i = !1;
	if (Fe) try {
		let e = new URL(window.location.href), r = n.startsWith("//") ? new URL(e.protocol + n) : new URL(n), a = M(r.pathname, t);
		r.origin === e.origin && a != null ? n = a + r.search + r.hash : i = !0;
	} catch {
		O(!1, `<Link to="${n}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
	}
	return {
		absoluteURL: r,
		isExternal: i,
		to: n
	};
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
var Le = [
	"POST",
	"PUT",
	"PATCH",
	"DELETE"
];
new Set(Le);
var Re = ["GET", ...Le];
new Set(Re);
var I = r.createContext(null);
I.displayName = "DataRouter";
var L = r.createContext(null);
L.displayName = "DataRouterState";
var ze = r.createContext(!1);
function Be() {
	return r.useContext(ze);
}
var Ve = r.createContext({ isTransitioning: !1 });
Ve.displayName = "ViewTransition";
var He = r.createContext(/* @__PURE__ */ new Map());
He.displayName = "Fetchers";
var Ue = r.createContext(null);
Ue.displayName = "Await";
var R = r.createContext(null);
R.displayName = "Navigation";
var z = r.createContext(null);
z.displayName = "Location";
var B = r.createContext({
	outlet: null,
	matches: [],
	isDataRoute: !1
});
B.displayName = "Route";
var V = r.createContext(null);
V.displayName = "RouteError";
var We = "REACT_ROUTER_ERROR", Ge = "REDIRECT", Ke = "ROUTE_ERROR_RESPONSE";
function qe(e) {
	if (e.startsWith(`${We}:${Ge}:{`)) try {
		let t = JSON.parse(e.slice(28));
		if (typeof t == "object" && t && typeof t.status == "number" && typeof t.statusText == "string" && typeof t.location == "string" && typeof t.reloadDocument == "boolean" && typeof t.replace == "boolean") return t;
	} catch {}
}
function Je(e) {
	if (e.startsWith(`${We}:${Ke}:{`)) try {
		let t = JSON.parse(e.slice(40));
		if (typeof t == "object" && t && typeof t.status == "number" && typeof t.statusText == "string") return new Me(t.status, t.statusText, t.data);
	} catch {}
}
function Ye(e, { relative: t } = {}) {
	D(H(), "useHref() may be used only in the context of a <Router> component.");
	let { basename: n, navigator: i } = r.useContext(R), { hash: a, pathname: o, search: s } = W(e, { relative: t }), c = o;
	return n !== "/" && (c = o === "/" ? n : P([n, o])), i.createHref({
		pathname: c,
		search: s,
		hash: a
	});
}
function H() {
	return r.useContext(z) != null;
}
function U() {
	return D(H(), "useLocation() may be used only in the context of a <Router> component."), r.useContext(z).location;
}
var Xe = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function Ze(e) {
	r.useContext(R).static || r.useLayoutEffect(e);
}
function Qe() {
	let { isDataRoute: e } = r.useContext(B);
	return e ? _t() : $e();
}
function $e() {
	D(H(), "useNavigate() may be used only in the context of a <Router> component.");
	let e = r.useContext(I), { basename: t, navigator: n } = r.useContext(R), { matches: i } = r.useContext(B), { pathname: a } = U(), o = JSON.stringify(Ee(i)), s = r.useRef(!1);
	return Ze(() => {
		s.current = !0;
	}), r.useCallback((r, i = {}) => {
		if (O(s.current, Xe), !s.current) return;
		if (typeof r == "number") {
			n.go(r);
			return;
		}
		let c = De(r, JSON.parse(o), a, i.relative === "path");
		e == null && t !== "/" && (c.pathname = c.pathname === "/" ? t : P([t, c.pathname])), (i.replace ? n.replace : n.push)(c, i.state, i);
	}, [
		t,
		n,
		o,
		a,
		e
	]);
}
r.createContext(null);
function W(e, { relative: t } = {}) {
	let { matches: n } = r.useContext(B), { pathname: i } = U(), a = JSON.stringify(Ee(n));
	return r.useMemo(() => De(e, JSON.parse(a), i, t === "path"), [
		e,
		a,
		i,
		t
	]);
}
function et(e, t, n) {
	D(H(), "useRoutes() may be used only in the context of a <Router> component.");
	let { navigator: i } = r.useContext(R), { matches: a } = r.useContext(B), o = a[a.length - 1], s = o ? o.params : {}, c = o ? o.pathname : "/", l = o ? o.pathnameBase : "/", u = o && o.route;
	{
		let e = u && u.path || "";
		yt(c, !u || e.endsWith("*") || e.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${c}" (under <Route path="${e}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${e}"> to <Route path="${e === "/" ? "*" : `${e}/*`}">.`);
	}
	let d = U(), f;
	if (t) {
		let e = typeof t == "string" ? A(t) : t;
		D(l === "/" || e.pathname?.startsWith(l), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${l}" but pathname "${e.pathname}" was given in the \`location\` prop.`), f = e;
	} else f = d;
	let p = f.pathname || "/", m = p;
	if (l !== "/") {
		let e = l.replace(/^\//, "").split("/");
		m = "/" + p.replace(/^\//, "").split("/").slice(e.length).join("/");
	}
	let h = n && n.state.matches.length ? n.state.matches.map((e) => Object.assign(e, { route: n.manifest[e.route.id] || e.route })) : re(e, { pathname: m });
	O(u || h != null, `No routes matched location "${f.pathname}${f.search}${f.hash}" `), O(h == null || h[h.length - 1].route.element !== void 0 || h[h.length - 1].route.Component !== void 0 || h[h.length - 1].route.lazy !== void 0, `Matched leaf route at location "${f.pathname}${f.search}${f.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
	let g = st(h && h.map((e) => Object.assign({}, e, {
		params: Object.assign({}, s, e.params),
		pathname: P([l, i.encodeLocation ? i.encodeLocation(e.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : e.pathname]),
		pathnameBase: e.pathnameBase === "/" ? l : P([l, i.encodeLocation ? i.encodeLocation(e.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : e.pathnameBase])
	})), a, n);
	return t && g ? /* @__PURE__ */ r.createElement(z.Provider, { value: {
		location: {
			pathname: "/",
			search: "",
			hash: "",
			state: null,
			key: "default",
			mask: void 0,
			...f
		},
		navigationType: "POP"
	} }, g) : g;
}
function tt() {
	let e = gt(), t = Ne(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), n = e instanceof Error ? e.stack : null, i = "rgba(200,200,200, 0.5)", a = {
		padding: "0.5rem",
		backgroundColor: i
	}, o = {
		padding: "2px 4px",
		backgroundColor: i
	}, s = null;
	return console.error("Error handled by React Router default ErrorBoundary:", e), s = /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ r.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ r.createElement("code", { style: o }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ r.createElement("code", { style: o }, "errorElement"), " prop on your route.")), /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ r.createElement("h3", { style: { fontStyle: "italic" } }, t), n ? /* @__PURE__ */ r.createElement("pre", { style: a }, n) : null, s);
}
var nt = /* @__PURE__ */ r.createElement(tt, null), rt = class extends r.Component {
	constructor(e) {
		super(e), this.state = {
			location: e.location,
			revalidation: e.revalidation,
			error: e.error
		};
	}
	static getDerivedStateFromError(e) {
		return { error: e };
	}
	static getDerivedStateFromProps(e, t) {
		return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
			error: e.error,
			location: e.location,
			revalidation: e.revalidation
		} : {
			error: e.error === void 0 ? t.error : e.error,
			location: t.location,
			revalidation: e.revalidation || t.revalidation
		};
	}
	componentDidCatch(e, t) {
		this.props.onError ? this.props.onError(e, t) : console.error("React Router caught the following error during render", e);
	}
	render() {
		let e = this.state.error;
		if (this.context && typeof e == "object" && e && "digest" in e && typeof e.digest == "string") {
			let t = Je(e.digest);
			t && (e = t);
		}
		let t = e === void 0 ? this.props.children : /* @__PURE__ */ r.createElement(B.Provider, { value: this.props.routeContext }, /* @__PURE__ */ r.createElement(V.Provider, {
			value: e,
			children: this.props.component
		}));
		return this.context ? /* @__PURE__ */ r.createElement(at, { error: e }, t) : t;
	}
};
rt.contextType = ze;
var it = /* @__PURE__ */ new WeakMap();
function at({ children: e, error: t }) {
	let { basename: n } = r.useContext(R);
	if (typeof t == "object" && t && "digest" in t && typeof t.digest == "string") {
		let e = qe(t.digest);
		if (e) {
			let i = it.get(t);
			if (i) throw i;
			let a = Ie(e.location, n);
			if (Fe && !it.get(t)) if (a.isExternal || e.reloadDocument) window.location.href = a.absoluteURL || a.to;
			else {
				let n = Promise.resolve().then(() => window.__reactRouterDataRouter.navigate(a.to, { replace: e.replace }));
				throw it.set(t, n), n;
			}
			return /* @__PURE__ */ r.createElement("meta", {
				httpEquiv: "refresh",
				content: `0;url=${a.absoluteURL || a.to}`
			});
		}
	}
	return e;
}
function ot({ routeContext: e, match: t, children: n }) {
	let i = r.useContext(I);
	return i && i.static && i.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (i.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ r.createElement(B.Provider, { value: e }, n);
}
function st(e, t = [], n) {
	let i = n?.state;
	if (e == null) {
		if (!i) return null;
		if (i.errors) e = i.matches;
		else if (t.length === 0 && !i.initialized && i.matches.length > 0) e = i.matches;
		else return null;
	}
	let a = e, o = i?.errors;
	if (o != null) {
		let e = a.findIndex((e) => e.route.id && o?.[e.route.id] !== void 0);
		D(e >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(o).join(",")}`), a = a.slice(0, Math.min(a.length, e + 1));
	}
	let s = !1, c = -1;
	if (n && i) {
		s = i.renderFallback;
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			if ((t.route.HydrateFallback || t.route.hydrateFallbackElement) && (c = e), t.route.id) {
				let { loaderData: e, errors: r } = i, o = t.route.loader && !e.hasOwnProperty(t.route.id) && (!r || r[t.route.id] === void 0);
				if (t.route.lazy || o) {
					n.isStatic && (s = !0), a = c >= 0 ? a.slice(0, c + 1) : [a[0]];
					break;
				}
			}
		}
	}
	let l = n?.onError, u = i && l ? (e, t) => {
		l(e, {
			location: i.location,
			params: i.matches?.[0]?.params ?? {},
			pattern: Pe(i.matches),
			errorInfo: t
		});
	} : void 0;
	return a.reduceRight((e, n, l) => {
		let d, f = !1, p = null, m = null;
		i && (d = o && n.route.id ? o[n.route.id] : void 0, p = n.route.errorElement || nt, s && (c < 0 && l === 0 ? (yt("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), f = !0, m = null) : c === l && (f = !0, m = n.route.hydrateFallbackElement || null)));
		let h = t.concat(a.slice(0, l + 1)), g = () => {
			let t;
			return t = d ? p : f ? m : n.route.Component ? /* @__PURE__ */ r.createElement(n.route.Component, null) : n.route.element ? n.route.element : e, /* @__PURE__ */ r.createElement(ot, {
				match: n,
				routeContext: {
					outlet: e,
					matches: h,
					isDataRoute: i != null
				},
				children: t
			});
		};
		return i && (n.route.ErrorBoundary || n.route.errorElement || l === 0) ? /* @__PURE__ */ r.createElement(rt, {
			location: i.location,
			revalidation: i.revalidation,
			component: p,
			error: d,
			children: g(),
			routeContext: {
				outlet: null,
				matches: h,
				isDataRoute: !0
			},
			onError: u
		}) : g();
	}, null);
}
function ct(e) {
	return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function lt(e) {
	let t = r.useContext(I);
	return D(t, ct(e)), t;
}
function ut(e) {
	let t = r.useContext(L);
	return D(t, ct(e)), t;
}
function dt(e) {
	let t = r.useContext(B);
	return D(t, ct(e)), t;
}
function ft(e) {
	let t = dt(e), n = t.matches[t.matches.length - 1];
	return D(n.route.id, `${e} can only be used on routes that contain a unique "id"`), n.route.id;
}
function pt() {
	return ft("useRouteId");
}
function mt() {
	let e = ut("useNavigation");
	return r.useMemo(() => {
		let { matches: t, historyAction: n, ...r } = e.navigation;
		return r;
	}, [e.navigation]);
}
function ht() {
	let { matches: e, loaderData: t } = ut("useMatches");
	return r.useMemo(() => e.map((e) => ae(e, t)), [e, t]);
}
function gt() {
	let e = r.useContext(V), t = ut("useRouteError"), n = ft("useRouteError");
	return e === void 0 ? t.errors?.[n] : e;
}
function _t() {
	let { router: e } = lt("useNavigate"), t = ft("useNavigate"), n = r.useRef(!1);
	return Ze(() => {
		n.current = !0;
	}), r.useCallback(async (r, i = {}) => {
		O(n.current, Xe), n.current && (typeof r == "number" ? await e.navigate(r) : await e.navigate(r, {
			fromRouteId: t,
			...i
		}));
	}, [e, t]);
}
var vt = {};
function yt(e, t, n) {
	!t && !vt[e] && (vt[e] = !0, O(!1, n));
}
r.memo(bt);
function bt({ routes: e, manifest: t, future: n, state: r, isStatic: i, onError: a }) {
	return et(e, void 0, {
		manifest: t,
		state: r,
		isStatic: i,
		onError: a,
		future: n
	});
}
function xt({ basename: e = "/", children: t = null, location: n, navigationType: i = "POP", navigator: a, static: o = !1, useTransitions: s }) {
	D(!H(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
	let c = e.replace(/^\/*/, "/"), l = r.useMemo(() => ({
		basename: c,
		navigator: a,
		static: o,
		useTransitions: s,
		future: {}
	}), [
		c,
		a,
		o,
		s
	]);
	typeof n == "string" && (n = A(n));
	let { pathname: u = "/", search: d = "", hash: f = "", state: p = null, key: m = "default", mask: h } = n, g = r.useMemo(() => {
		let e = M(u, c);
		return e == null ? null : {
			location: {
				pathname: e,
				search: d,
				hash: f,
				state: p,
				key: m,
				mask: h
			},
			navigationType: i
		};
	}, [
		c,
		u,
		d,
		f,
		p,
		m,
		i,
		h
	]);
	return O(g != null, `<Router basename="${c}"> is not able to match the URL "${u}${d}${f}" because it does not start with the basename, so the <Router> won't render anything.`), g == null ? null : /* @__PURE__ */ r.createElement(R.Provider, { value: l }, /* @__PURE__ */ r.createElement(z.Provider, {
		children: t,
		value: g
	}));
}
r.Component;
var G = "get", K = "application/x-www-form-urlencoded";
function q(e) {
	return typeof HTMLElement < "u" && e instanceof HTMLElement;
}
function St(e) {
	return q(e) && e.tagName.toLowerCase() === "button";
}
function Ct(e) {
	return q(e) && e.tagName.toLowerCase() === "form";
}
function wt(e) {
	return q(e) && e.tagName.toLowerCase() === "input";
}
function Tt(e) {
	return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Et(e, t) {
	return e.button === 0 && (!t || t === "_self") && !Tt(e);
}
var J = null;
function Dt() {
	if (J === null) try {
		new FormData(document.createElement("form"), 0), J = !1;
	} catch {
		J = !0;
	}
	return J;
}
var Ot = /* @__PURE__ */ new Set([
	"application/x-www-form-urlencoded",
	"multipart/form-data",
	"text/plain"
]);
function kt(e) {
	return e != null && !Ot.has(e) ? (O(!1, `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${K}"`), null) : e;
}
function At(e, t) {
	let n, r, i, a, o;
	if (Ct(e)) {
		let o = e.getAttribute("action");
		r = o ? M(o, t) : null, n = e.getAttribute("method") || G, i = kt(e.getAttribute("enctype")) || K, a = new FormData(e);
	} else if (St(e) || wt(e) && (e.type === "submit" || e.type === "image")) {
		let o = e.form;
		if (o == null) throw Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
		let s = e.getAttribute("formaction") || o.getAttribute("action");
		if (r = s ? M(s, t) : null, n = e.getAttribute("formmethod") || o.getAttribute("method") || G, i = kt(e.getAttribute("formenctype")) || kt(o.getAttribute("enctype")) || K, a = new FormData(o, e), !Dt()) {
			let { name: t, type: n, value: r } = e;
			if (n === "image") {
				let e = t ? `${t}.` : "";
				a.append(`${e}x`, "0"), a.append(`${e}y`, "0");
			} else t && a.append(t, r);
		}
	} else if (q(e)) throw Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
	else n = G, r = null, i = K, o = e;
	return a && i === "text/plain" && (o = a, a = void 0), {
		action: r,
		method: n.toLowerCase(),
		encType: i,
		formData: a,
		body: o
	};
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
var jt = {
	"&": "\\u0026",
	">": "\\u003e",
	"<": "\\u003c",
	"\u2028": "\\u2028",
	"\u2029": "\\u2029"
}, Mt = /[&><\u2028\u2029]/g;
function Nt(e) {
	return e.replace(Mt, (e) => jt[e]);
}
function Pt(e, t) {
	if (e === !1 || e == null) throw Error(t);
}
function Ft(e, t, n, r) {
	let i = typeof e == "string" ? new URL(e, typeof window > "u" ? "server://singlefetch/" : window.location.origin) : e;
	return n ? i.pathname.endsWith("/") ? i.pathname = `${i.pathname}_.${r}` : i.pathname = `${i.pathname}.${r}` : i.pathname === "/" ? i.pathname = `_root.${r}` : t && M(i.pathname, t) === "/" ? i.pathname = `${F(t)}/_root.${r}` : i.pathname = `${F(i.pathname)}.${r}`, i;
}
async function It(e, t) {
	if (e.id in t) return t[e.id];
	try {
		let n = await import(
			/* @vite-ignore */
			/* webpackIgnore: true */
			e.module
);
		return t[e.id] = n, n;
	} catch (t) {
		return console.error(`Error loading route module \`${e.module}\`, reloading page...`), console.error(t), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {});
	}
}
function Lt(e) {
	return e != null && typeof e.page == "string";
}
function Rt(e) {
	return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function zt(e, t, n) {
	return Wt((await Promise.all(e.map(async (e) => {
		let r = t.routes[e.route.id];
		if (r) {
			let e = await It(r, n);
			return e.links ? e.links() : [];
		}
		return [];
	}))).flat(1).filter(Rt).filter((e) => e.rel === "stylesheet" || e.rel === "preload").map((e) => e.rel === "stylesheet" ? {
		...e,
		rel: "prefetch",
		as: "style"
	} : {
		...e,
		rel: "prefetch"
	}));
}
function Bt(e, t, n, r, i, a) {
	let o = (e, t) => n[t] ? e.route.id !== n[t].route.id : !0, s = (e, t) => n[t].pathname !== e.pathname || n[t].route.path?.endsWith("*") && n[t].params["*"] !== e.params["*"];
	return a === "assets" ? t.filter((e, t) => o(e, t) || s(e, t)) : a === "data" ? t.filter((t, a) => {
		let c = r.routes[t.route.id];
		if (!c || !c.hasLoader) return !1;
		if (o(t, a) || s(t, a)) return !0;
		if (t.route.shouldRevalidate) {
			let r = t.route.shouldRevalidate({
				currentUrl: new URL(i.pathname + i.search + i.hash, window.origin),
				currentParams: n[0]?.params || {},
				nextUrl: new URL(e, window.origin),
				nextParams: t.params,
				defaultShouldRevalidate: !0
			});
			if (typeof r == "boolean") return r;
		}
		return !0;
	}) : [];
}
function Vt(e, t, { includeHydrateFallback: n } = {}) {
	return Ht(e.map((e) => {
		let r = t.routes[e.route.id];
		if (!r) return [];
		let i = [r.module];
		return r.clientActionModule && (i = i.concat(r.clientActionModule)), r.clientLoaderModule && (i = i.concat(r.clientLoaderModule)), n && r.hydrateFallbackModule && (i = i.concat(r.hydrateFallbackModule)), r.imports && (i = i.concat(r.imports)), i;
	}).flat(1));
}
function Ht(e) {
	return [...new Set(e)];
}
function Ut(e) {
	let t = {}, n = Object.keys(e).sort();
	for (let r of n) t[r] = e[r];
	return t;
}
function Wt(e, t) {
	let n = /* @__PURE__ */ new Set(), r = new Set(t);
	return e.reduce((e, i) => {
		if (t && !Lt(i) && i.as === "script" && i.href && r.has(i.href)) return e;
		let a = JSON.stringify(Ut(i));
		return n.has(a) || (n.add(a), e.push({
			key: a,
			link: i
		})), e;
	}, []);
}
function Gt() {
	let e = r.useContext(I);
	return Pt(e, "You must render this element inside a <DataRouterContext.Provider> element"), e;
}
function Kt() {
	let e = r.useContext(L);
	return Pt(e, "You must render this element inside a <DataRouterStateContext.Provider> element"), e;
}
var Y = r.createContext(void 0);
Y.displayName = "FrameworkContext";
function qt() {
	let e = r.useContext(Y);
	return Pt(e, "You must render this element inside a <HydratedRouter> element"), e;
}
function Jt(e, t) {
	let n = r.useContext(Y), [i, a] = r.useState(!1), [o, s] = r.useState(!1), { onFocus: c, onBlur: l, onMouseEnter: u, onMouseLeave: d, onTouchStart: f } = t, p = r.useRef(null);
	r.useEffect(() => {
		if (e === "render" && s(!0), e === "viewport") {
			let e = new IntersectionObserver((e) => {
				e.forEach((e) => {
					s(e.isIntersecting);
				});
			}, { threshold: .5 });
			return p.current && e.observe(p.current), () => {
				e.disconnect();
			};
		}
	}, [e]), r.useEffect(() => {
		if (i) {
			let e = setTimeout(() => {
				s(!0);
			}, 100);
			return () => {
				clearTimeout(e);
			};
		}
	}, [i]);
	let m = () => {
		a(!0);
	}, h = () => {
		a(!1), s(!1);
	};
	return n ? e === "intent" ? [
		o,
		p,
		{
			onFocus: X(c, m),
			onBlur: X(l, h),
			onMouseEnter: X(u, m),
			onMouseLeave: X(d, h),
			onTouchStart: X(f, m)
		}
	] : [
		o,
		p,
		{}
	] : [
		!1,
		p,
		{}
	];
}
function X(e, t) {
	return (n) => {
		e && e(n), n.defaultPrevented || t(n);
	};
}
function Yt({ page: e, ...t }) {
	let n = Be(), { router: i } = Gt(), a = r.useMemo(() => re(i.routes, e, i.basename), [
		i.routes,
		e,
		i.basename
	]);
	return a ? n ? /* @__PURE__ */ r.createElement(Zt, {
		page: e,
		matches: a,
		...t
	}) : /* @__PURE__ */ r.createElement(Qt, {
		page: e,
		matches: a,
		...t
	}) : null;
}
function Xt(e) {
	let { manifest: t, routeModules: n } = qt(), [i, a] = r.useState([]);
	return r.useEffect(() => {
		let r = !1;
		return zt(e, t, n).then((e) => {
			r || a(e);
		}), () => {
			r = !0;
		};
	}, [
		e,
		t,
		n
	]), i;
}
function Zt({ page: e, matches: t, ...n }) {
	let i = U(), { future: a } = qt(), { basename: o } = Gt(), s = r.useMemo(() => {
		if (e === i.pathname + i.search + i.hash) return [];
		let n = Ft(e, o, a.v8_trailingSlashAwareDataRequests, "rsc"), r = !1, s = [];
		for (let e of t) typeof e.route.shouldRevalidate == "function" ? r = !0 : s.push(e.route.id);
		return r && s.length > 0 && n.searchParams.set("_routes", s.join(",")), [n.pathname + n.search];
	}, [
		o,
		a.v8_trailingSlashAwareDataRequests,
		e,
		i,
		t
	]);
	return /* @__PURE__ */ r.createElement(r.Fragment, null, s.map((e) => /* @__PURE__ */ r.createElement("link", {
		key: e,
		rel: "prefetch",
		as: "fetch",
		href: e,
		...n
	})));
}
function Qt({ page: e, matches: t, ...n }) {
	let i = U(), { future: a, manifest: o, routeModules: s } = qt(), { basename: c } = Gt(), { loaderData: l, matches: u } = Kt(), d = r.useMemo(() => Bt(e, t, u, o, i, "data"), [
		e,
		t,
		u,
		o,
		i
	]), f = r.useMemo(() => Bt(e, t, u, o, i, "assets"), [
		e,
		t,
		u,
		o,
		i
	]), p = r.useMemo(() => {
		if (e === i.pathname + i.search + i.hash) return [];
		let n = /* @__PURE__ */ new Set(), r = !1;
		if (t.forEach((e) => {
			let t = o.routes[e.route.id];
			!t || !t.hasLoader || (!d.some((t) => t.route.id === e.route.id) && e.route.id in l && s[e.route.id]?.shouldRevalidate || t.hasClientLoader ? r = !0 : n.add(e.route.id));
		}), n.size === 0) return [];
		let u = Ft(e, c, a.v8_trailingSlashAwareDataRequests, "data");
		return r && n.size > 0 && u.searchParams.set("_routes", t.filter((e) => n.has(e.route.id)).map((e) => e.route.id).join(",")), [u.pathname + u.search];
	}, [
		c,
		a.v8_trailingSlashAwareDataRequests,
		l,
		i,
		o,
		d,
		t,
		e,
		s
	]), m = r.useMemo(() => Vt(f, o), [f, o]), h = Xt(f);
	return /* @__PURE__ */ r.createElement(r.Fragment, null, p.map((e) => /* @__PURE__ */ r.createElement("link", {
		key: e,
		rel: "prefetch",
		as: "fetch",
		href: e,
		...n
	})), m.map((e) => /* @__PURE__ */ r.createElement("link", {
		key: e,
		rel: "modulepreload",
		href: e,
		...n
	})), h.map(({ key: e, link: t }) => /* @__PURE__ */ r.createElement("link", {
		key: e,
		nonce: n.nonce,
		...t,
		crossOrigin: t.crossOrigin ?? n.crossOrigin
	})));
}
function $t(...e) {
	return (t) => {
		e.forEach((e) => {
			typeof e == "function" ? e(t) : e != null && (e.current = t);
		});
	};
}
r.Component;
var en = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0;
try {
	en && (window.__reactRouterVersion = "7.17.0");
} catch {}
function tn({ basename: e, children: t, history: n, useTransitions: i }) {
	let [a, o] = r.useState({
		action: n.action,
		location: n.location
	}), s = r.useCallback((e) => {
		i === !1 ? o(e) : r.startTransition(() => o(e));
	}, [i]);
	return r.useLayoutEffect(() => n.listen(s), [n, s]), /* @__PURE__ */ r.createElement(xt, {
		basename: e,
		children: t,
		location: a.location,
		navigationType: a.action,
		navigator: n,
		useTransitions: i
	});
}
tn.displayName = "unstable_HistoryRouter";
var nn = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Z = r.forwardRef(function({ onClick: e, discover: t = "render", prefetch: n = "none", relative: i, reloadDocument: a, replace: o, mask: s, state: c, target: l, to: u, preventScrollReset: d, viewTransition: f, defaultShouldRevalidate: p, ...m }, h) {
	let { basename: g, navigator: _, useTransitions: v } = r.useContext(R), y = typeof u == "string" && nn.test(u), b = Ie(u, g);
	u = b.to;
	let x = Ye(u, { relative: i }), S = U(), C = null;
	if (s) {
		let e = De(s, [], S.mask ? S.mask.pathname : "/", !0);
		g !== "/" && (e.pathname = e.pathname === "/" ? g : P([g, e.pathname])), C = _.createHref(e);
	}
	let [w, T, ee] = Jt(n, m), te = un(u, {
		replace: o,
		mask: s,
		state: c,
		target: l,
		preventScrollReset: d,
		relative: i,
		viewTransition: f,
		defaultShouldRevalidate: p,
		useTransitions: v
	});
	function ne(t) {
		e && e(t), t.defaultPrevented || te(t);
	}
	let E = !(b.isExternal || a), D = /* @__PURE__ */ r.createElement("a", {
		...m,
		...ee,
		href: (E ? C : void 0) || b.absoluteURL || x,
		onClick: E ? ne : e,
		ref: $t(h, T),
		target: l,
		"data-discover": !y && t === "render" ? "true" : void 0
	});
	return w && !y ? /* @__PURE__ */ r.createElement(r.Fragment, null, D, /* @__PURE__ */ r.createElement(Yt, { page: x })) : D;
});
Z.displayName = "Link";
var rn = r.forwardRef(function({ "aria-current": e = "page", caseSensitive: t = !1, className: n = "", end: i = !1, style: a, to: o, viewTransition: s, children: c, ...l }, u) {
	let d = W(o, { relative: l.relative }), f = U(), p = r.useContext(L), { navigator: m, basename: h } = r.useContext(R), g = p != null && yn(d) && s === !0, _ = m.encodeLocation ? m.encodeLocation(d).pathname : d.pathname, v = f.pathname, y = p && p.navigation && p.navigation.location ? p.navigation.location.pathname : null;
	t || (v = v.toLowerCase(), y = y ? y.toLowerCase() : null, _ = _.toLowerCase()), y && h && (y = M(y, h) || y);
	let b = _ !== "/" && _.endsWith("/") ? _.length - 1 : _.length, x = v === _ || !i && v.startsWith(_) && v.charAt(b) === "/", S = y != null && (y === _ || !i && y.startsWith(_) && y.charAt(_.length) === "/"), C = {
		isActive: x,
		isPending: S,
		isTransitioning: g
	}, w = x ? e : void 0, T;
	T = typeof n == "function" ? n(C) : [
		n,
		x ? "active" : null,
		S ? "pending" : null,
		g ? "transitioning" : null
	].filter(Boolean).join(" ");
	let ee = typeof a == "function" ? a(C) : a;
	return /* @__PURE__ */ r.createElement(Z, {
		...l,
		"aria-current": w,
		className: T,
		ref: u,
		style: ee,
		to: o,
		viewTransition: s
	}, typeof c == "function" ? c(C) : c);
});
rn.displayName = "NavLink";
var an = r.forwardRef(({ discover: e = "render", fetcherKey: t, navigate: n, reloadDocument: i, replace: a, state: o, method: s = G, action: c, onSubmit: l, relative: u, preventScrollReset: d, viewTransition: f, defaultShouldRevalidate: p, ...m }, h) => {
	let { useTransitions: g } = r.useContext(R), _ = pn(), v = mn(c, { relative: u }), y = s.toLowerCase() === "get" ? "get" : "post", b = typeof c == "string" && nn.test(c);
	return /* @__PURE__ */ r.createElement("form", {
		ref: h,
		method: y,
		action: v,
		onSubmit: i ? l : (e) => {
			if (l && l(e), e.defaultPrevented) return;
			e.preventDefault();
			let i = e.nativeEvent.submitter, c = i?.getAttribute("formmethod") || s, m = () => _(i || e.currentTarget, {
				fetcherKey: t,
				method: c,
				navigate: n,
				replace: a,
				state: o,
				relative: u,
				preventScrollReset: d,
				viewTransition: f,
				defaultShouldRevalidate: p
			});
			g && n !== !1 ? r.startTransition(() => m()) : m();
		},
		...m,
		"data-discover": !b && e === "render" ? "true" : void 0
	});
});
an.displayName = "Form";
function on({ getKey: e, storageKey: t, ...n }) {
	let i = r.useContext(Y), { basename: a } = r.useContext(R), o = U(), s = ht();
	_n({
		getKey: e,
		storageKey: t
	});
	let c = r.useMemo(() => {
		if (!i || !e) return null;
		let t = gn(o, s, a, e);
		return t === o.key ? null : t;
	}, []);
	if (!i || i.isSpaMode) return null;
	let l = ((e, t) => {
		if (!window.history.state || !window.history.state.key) {
			let e = Math.random().toString(32).slice(2);
			window.history.replaceState({ key: e }, "");
		}
		try {
			let n = JSON.parse(sessionStorage.getItem(e) || "{}")[t || window.history.state.key];
			typeof n == "number" && window.scrollTo(0, n);
		} catch (t) {
			console.error(t), sessionStorage.removeItem(e);
		}
	}).toString();
	return /* @__PURE__ */ r.createElement("script", {
		...n,
		suppressHydrationWarning: !0,
		dangerouslySetInnerHTML: { __html: `(${l})(${Nt(JSON.stringify(t || hn))}, ${Nt(JSON.stringify(c))})` }
	});
}
on.displayName = "ScrollRestoration";
function sn(e) {
	return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function cn(e) {
	let t = r.useContext(I);
	return D(t, sn(e)), t;
}
function ln(e) {
	let t = r.useContext(L);
	return D(t, sn(e)), t;
}
function un(e, { target: t, replace: n, mask: i, state: a, preventScrollReset: o, relative: s, viewTransition: c, defaultShouldRevalidate: l, useTransitions: u } = {}) {
	let d = Qe(), f = U(), p = W(e, { relative: s });
	return r.useCallback((m) => {
		if (Et(m, t)) {
			m.preventDefault();
			let t = n === void 0 ? k(f) === k(p) : n, h = () => d(e, {
				replace: t,
				mask: i,
				state: a,
				preventScrollReset: o,
				relative: s,
				viewTransition: c,
				defaultShouldRevalidate: l
			});
			u ? r.startTransition(() => h()) : h();
		}
	}, [
		f,
		d,
		p,
		n,
		i,
		a,
		t,
		e,
		o,
		s,
		c,
		l,
		u
	]);
}
var dn = 0, fn = () => `__${String(++dn)}__`;
function pn() {
	let { router: e } = cn("useSubmit"), { basename: t } = r.useContext(R), n = pt(), i = e.fetch, a = e.navigate;
	return r.useCallback(async (e, r = {}) => {
		let { action: o, method: s, encType: c, formData: l, body: u } = At(e, t);
		r.navigate === !1 ? await i(r.fetcherKey || fn(), n, r.action || o, {
			defaultShouldRevalidate: r.defaultShouldRevalidate,
			preventScrollReset: r.preventScrollReset,
			formData: l,
			body: u,
			formMethod: r.method || s,
			formEncType: r.encType || c,
			flushSync: r.flushSync
		}) : await a(r.action || o, {
			defaultShouldRevalidate: r.defaultShouldRevalidate,
			preventScrollReset: r.preventScrollReset,
			formData: l,
			body: u,
			formMethod: r.method || s,
			formEncType: r.encType || c,
			replace: r.replace,
			state: r.state,
			fromRouteId: n,
			flushSync: r.flushSync,
			viewTransition: r.viewTransition
		});
	}, [
		i,
		a,
		t,
		n
	]);
}
function mn(e, { relative: t } = {}) {
	let { basename: n } = r.useContext(R), i = r.useContext(B);
	D(i, "useFormAction must be used inside a RouteContext");
	let [a] = i.matches.slice(-1), o = { ...W(e || ".", { relative: t }) }, s = U();
	if (e == null) {
		o.search = s.search;
		let e = new URLSearchParams(o.search), t = e.getAll("index");
		if (t.some((e) => e === "")) {
			e.delete("index"), t.filter((e) => e).forEach((t) => e.append("index", t));
			let n = e.toString();
			o.search = n ? `?${n}` : "";
		}
	}
	return (!e || e === ".") && a.route.index && (o.search = o.search ? o.search.replace(/^\?/, "?index&") : "?index"), n !== "/" && (o.pathname = o.pathname === "/" ? n : P([n, o.pathname])), k(o);
}
var hn = "react-router-scroll-positions", Q = {};
function gn(e, t, n, r) {
	let i = null;
	return r && (i = r(n === "/" ? e : {
		...e,
		pathname: M(e.pathname, n) || e.pathname
	}, t)), i ??= e.key, i;
}
function _n({ getKey: e, storageKey: t } = {}) {
	let { router: n } = cn("useScrollRestoration"), { restoreScrollPosition: i, preventScrollReset: a } = ln("useScrollRestoration"), { basename: o } = r.useContext(R), s = U(), c = ht(), l = mt();
	r.useEffect(() => (window.history.scrollRestoration = "manual", () => {
		window.history.scrollRestoration = "auto";
	}), []), vn(r.useCallback(() => {
		if (l.state === "idle") {
			let t = gn(s, c, o, e);
			Q[t] = window.scrollY;
		}
		try {
			sessionStorage.setItem(t || hn, JSON.stringify(Q));
		} catch (e) {
			O(!1, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${e}).`);
		}
		window.history.scrollRestoration = "auto";
	}, [
		l.state,
		e,
		o,
		s,
		c,
		t
	])), typeof document < "u" && (r.useLayoutEffect(() => {
		try {
			let e = sessionStorage.getItem(t || hn);
			e && (Q = JSON.parse(e));
		} catch {}
	}, [t]), r.useLayoutEffect(() => {
		let t = n?.enableScrollRestoration(Q, () => window.scrollY, e ? (t, n) => gn(t, n, o, e) : void 0);
		return () => t && t();
	}, [
		n,
		o,
		e
	]), r.useLayoutEffect(() => {
		if (i !== !1) {
			if (typeof i == "number") {
				window.scrollTo(0, i);
				return;
			}
			try {
				if (s.hash) {
					let e = document.getElementById(decodeURIComponent(s.hash.slice(1)));
					if (e) {
						e.scrollIntoView();
						return;
					}
				}
			} catch {
				O(!1, `"${s.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
			}
			a !== !0 && window.scrollTo(0, 0);
		}
	}, [
		s,
		i,
		a
	]));
}
function vn(e, t) {
	let { capture: n } = t || {};
	r.useEffect(() => {
		let t = n == null ? void 0 : { capture: n };
		return window.addEventListener("pagehide", e, t), () => {
			window.removeEventListener("pagehide", e, t);
		};
	}, [e, n]);
}
function yn(e, { relative: t } = {}) {
	let n = r.useContext(Ve);
	D(n != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
	let { basename: i } = cn("useViewTransitionState"), a = W(e, { relative: t });
	if (!n.isTransitioning) return !1;
	let o = M(n.currentLocation.pathname, i) || n.currentLocation.pathname, s = M(n.nextLocation.pathname, i) || n.nextLocation.pathname;
	return j(a.pathname, s) != null || j(a.pathname, o) != null;
}
//#endregion
//#region ../constants/dist/lib/pricing.js
var bn = [
	{
		id: "starter",
		name: "Starter",
		description: "Perfect for individuals getting started with AI document management",
		monthlyPrice: "₹0",
		yearlyPrice: "₹0",
		features: [
			"50MB cloud storage",
			"Basic OCR with 95% accuracy",
			"AI processing for up to 5 documents/month",
			"Automatic categorization (10 categories)",
			"Simple reminder system",
			"Mobile app access",
			"Email support"
		],
		buttonText: "Start Free",
		buttonVariant: "secondary",
		storage: "50MB"
	},
	{
		id: "professional",
		name: "Professional",
		description: "Advanced AI features for power users and small businesses",
		monthlyPrice: "₹9",
		yearlyPrice: "₹99",
		features: [
			"10GB cloud storage",
			"Advanced OCR with 99.5% accuracy",
			"AI processing for up to 1000 documents/month",
			"Smart categorization (20+ categories)",
			"Predictive reminders and insights",
			"Advanced search with AI",
			"Priority email support",
			"Export capabilities",
			"Custom categories"
		],
		isPopular: !0,
		buttonText: "Start Professional",
		buttonVariant: "primary",
		storage: "10GB"
	},
	{
		id: "enterprise",
		name: "Enterprise",
		description: "Full AI suite with premium features for businesses and families",
		monthlyPrice: "",
		yearlyPrice: "",
		features: [
			"100GB cloud storage",
			"Unlimited AI document processing",
			"Premium OCR with handwriting recognition",
			"AI-powered analytics and insights",
			"Privacy-first data handling",
			"Advanced warranty management",
			"Multi-user collaboration",
			"API access for integrations",
			"24/7 phone and chat support",
			"Advanced security features",
			"Custom AI training",
			"Dedicated account manager",
			"SLA guarantee"
		],
		isPremium: !0,
		buttonText: "Contact Sales",
		buttonVariant: "premium",
		storage: "100GB"
	}
], xn = ({ icon: e, title: r, description: i }) => /* @__PURE__ */ n("div", {
	className: "bg-white p-6 rounded-xl shadow-md text-center",
	children: [
		/* @__PURE__ */ t("div", {
			className: "p-3 bg-gray-50 rounded-lg inline-block mb-4",
			children: e
		}),
		/* @__PURE__ */ t("h3", {
			className: "text-lg font-semibold text-gray-900 mb-2",
			children: r
		}),
		/* @__PURE__ */ t("p", {
			className: "text-gray-600 text-sm",
			children: i
		})
	]
}), Sn = ({ plan: e, billingPeriod: r, loading: i = null, onSubscribe: a }) => /* @__PURE__ */ n("div", {
	className: `relative bg-white p-8 rounded-2xl shadow-lg transition-all duration-300 hover:shadow-xl ${e.isPopular ? "ring-2 ring-teal-500 scale-105" : e.isPremium ? "ring-2 ring-purple-500" : ""}`,
	children: [
		e.isPopular && /* @__PURE__ */ t("div", {
			className: "absolute -top-4 left-1/2 transform -translate-x-1/2",
			children: /* @__PURE__ */ n("span", {
				className: "bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-medium flex items-center",
				children: [/* @__PURE__ */ t(te, { className: "h-4 w-4 mr-1" }), "Most Popular"]
			})
		}),
		e.isPremium && /* @__PURE__ */ t("div", {
			className: "absolute -top-4 left-1/2 transform -translate-x-1/2",
			children: /* @__PURE__ */ n("span", {
				className: "bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-full text-sm font-medium flex items-center",
				children: [/* @__PURE__ */ t(C, { className: "h-4 w-4 mr-1" }), "Premium AI"]
			})
		}),
		/* @__PURE__ */ n("div", {
			className: "text-center mb-8",
			children: [
				/* @__PURE__ */ t("h3", {
					className: "text-2xl font-bold text-gray-900 mb-2",
					children: e.name
				}),
				/* @__PURE__ */ t("p", {
					className: "text-gray-600 mb-4",
					children: e.description
				}),
				/* @__PURE__ */ n("div", {
					className: "flex items-baseline justify-center",
					children: [/* @__PURE__ */ t("span", {
						className: "text-4xl font-bold text-gray-900",
						children: r === "monthly" ? e.monthlyPrice : e.yearlyPrice
					}), !e.isPremium && /* @__PURE__ */ n("span", {
						className: "text-gray-600 ml-2",
						children: ["/", r]
					})]
				})
			]
		}),
		/* @__PURE__ */ t("ul", {
			className: "space-y-4 mb-8",
			children: e.features.map((e, r) => /* @__PURE__ */ n("li", {
				className: "flex items-start",
				children: [/* @__PURE__ */ t(b, { className: "h-5 w-5 text-teal-500 mr-3 mt-0.5 flex-shrink-0" }), /* @__PURE__ */ t("span", {
					className: "text-gray-700",
					children: e
				})]
			}, r))
		}),
		/* @__PURE__ */ t(() => {
			if (a) return /* @__PURE__ */ n("button", {
				onClick: () => a(e.id),
				disabled: i === e.id,
				className: `w-full inline-flex items-center justify-center px-6 py-3 font-medium rounded-lg transition-colors ${e.buttonVariant === "primary" ? "bg-teal-600 hover:bg-teal-700 text-white" : e.buttonVariant === "premium" ? "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white" : "bg-white hover:bg-gray-100 text-gray-800 border border-gray-300"} disabled:opacity-50`,
				children: [i === e.id ? /* @__PURE__ */ t(w, { className: "h-5 w-5 animate-spin mr-2" }) : null, e.buttonText]
			});
			try {
				return /* @__PURE__ */ t(Z, {
					to: "/#get-started",
					className: `w-full inline-flex items-center justify-center px-6 py-3 font-medium rounded-lg transition-colors ${e.buttonVariant === "primary" ? "bg-teal-600 hover:bg-teal-700 text-white" : e.buttonVariant === "premium" ? "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white" : "bg-white hover:bg-gray-100 text-gray-800 border border-gray-300"}`,
					children: e.buttonText
				});
			} catch {
				return /* @__PURE__ */ t("a", {
					href: "/#get-started",
					className: `w-full inline-flex items-center justify-center px-6 py-3 font-medium rounded-lg transition-colors ${e.buttonVariant === "primary" ? "bg-teal-600 hover:bg-teal-700 text-white" : e.buttonVariant === "premium" ? "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white" : "bg-white hover:bg-gray-100 text-gray-800 border border-gray-300"}`,
					children: e.buttonText
				});
			}
		}, {})
	]
}), Cn = ({ question: e, answer: r }) => /* @__PURE__ */ n("div", {
	className: "border-b border-gray-200 py-6 last:border-b-0",
	children: [/* @__PURE__ */ t("h3", {
		className: "text-lg font-semibold text-gray-900 mb-2",
		children: e
	}), /* @__PURE__ */ t("p", {
		className: "text-gray-600",
		children: r
	})]
}), wn = [
	{
		title: "AI-Powered OCR",
		description: "Industry-leading text extraction with 99.5% accuracy",
		icon: /* @__PURE__ */ t(y, { className: "h-6 w-6 text-teal-600" })
	},
	{
		title: "Smart Categorization",
		description: "Automatic organization using advanced AI algorithms",
		icon: /* @__PURE__ */ t(E, { className: "h-6 w-6 text-blue-600" })
	},
	{
		title: "Predictive Insights",
		description: "AI-driven analytics and future predictions",
		icon: /* @__PURE__ */ t(te, { className: "h-6 w-6 text-purple-600" })
	},
	{
		title: "Enterprise Security",
		description: "Bank-level encryption and compliance",
		icon: /* @__PURE__ */ t(ee, { className: "h-6 w-6 text-green-600" })
	}
], Tn = [
	{
		question: "What happens if I exceed my document limit?",
		answer: "You'll receive a notification when approaching your limit. You can upgrade your plan or purchase additional document processing credits."
	},
	{
		question: "Can I change plans anytime?",
		answer: "Yes! You can upgrade or downgrade your plan at any time. Changes take effect immediately with prorated billing."
	},
	{
		question: "Is there a free trial for paid plans?",
		answer: "Yes, we offer a 14-day free trial for all paid plans with full access to premium AI features."
	},
	{
		question: "What payment methods do you accept?",
		answer: "We accept all major credit cards, debit cards, UPI, and digital wallets through our secure payment partner Razorpay."
	}
], En = ({ currentSubscription: e, subscriptionLoading: r, loading: i, error: a, success: o, onSubscribe: s, showBackButton: l = !1, backButtonLink: u = "/" }) => {
	let [d, f] = c("yearly");
	if (r) return /* @__PURE__ */ t("div", {
		className: "flex justify-center items-center h-64",
		children: /* @__PURE__ */ t(w, { className: "h-8 w-8 animate-spin text-primary-600" })
	});
	let p = async (e) => {
		try {
			s && await s(e);
		} catch (e) {
			console.error("Error subscribing to plan:", e);
		}
	};
	return /* @__PURE__ */ t("div", {
		className: "pt-32 pb-20 bg-gray-50 min-h-screen",
		children: /* @__PURE__ */ n("div", {
			className: "container mx-auto px-4 md:px-6",
			children: [
				/* @__PURE__ */ t(() => {
					if (!l) return null;
					try {
						return /* @__PURE__ */ n(Z, {
							to: u,
							className: "inline-flex items-center text-teal-600 hover:text-teal-700 mb-8 transition-colors",
							children: [/* @__PURE__ */ t(v, { className: "h-4 w-4 mr-2" }), "Back to Home"]
						});
					} catch {
						return /* @__PURE__ */ n("a", {
							href: u,
							className: "inline-flex items-center text-teal-600 hover:text-teal-700 mb-8 transition-colors",
							children: [/* @__PURE__ */ t(v, { className: "h-4 w-4 mr-2" }), "Back to Home"]
						});
					}
				}, {}),
				/* @__PURE__ */ n("div", {
					className: "text-center max-w-4xl mx-auto mb-16",
					children: [
						/* @__PURE__ */ n("div", {
							className: "inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-medium mb-6",
							children: [/* @__PURE__ */ t(C, { className: "h-4 w-4 mr-2" }), "Transparent AI Pricing"]
						}),
						/* @__PURE__ */ t("h1", {
							className: "text-4xl md:text-5xl font-bold text-gray-900 mb-6",
							children: "Choose Your AI Plan"
						}),
						/* @__PURE__ */ t("p", {
							className: "text-xl text-gray-600 mb-8",
							children: "Flexible pricing for individuals, professionals, and enterprises. All plans include our core AI features with varying limits and capabilities."
						}),
						e?.status === "active" && /* @__PURE__ */ n("div", {
							className: "mt-4 inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-medium",
							children: [
								/* @__PURE__ */ t(S, { className: "h-4 w-4 mr-2" }),
								"Currently on",
								" ",
								bn.find((t) => t.id === e.plan_id)?.name || e.plan_id,
								" ",
								"plan"
							]
						}),
						a && /* @__PURE__ */ n("div", {
							className: "mt-4 bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg flex items-center space-x-2",
							children: [/* @__PURE__ */ t(x, { className: "h-5 w-5 flex-shrink-0" }), /* @__PURE__ */ t("span", { children: a })]
						}),
						o && /* @__PURE__ */ n("div", {
							className: "mt-4 bg-green-50 border border-green-200 text-green-700 p-4 rounded-lg flex items-center space-x-2",
							children: [/* @__PURE__ */ t(S, { className: "h-5 w-5 flex-shrink-0" }), /* @__PURE__ */ t("span", { children: o })]
						}),
						/* @__PURE__ */ n("div", {
							className: "flex items-center justify-center mb-12",
							children: [
								/* @__PURE__ */ t("span", {
									className: `mr-3 ${d === "monthly" ? "text-gray-900 font-medium" : "text-gray-600"}`,
									children: "Monthly"
								}),
								/* @__PURE__ */ t("button", {
									onClick: () => f(d === "monthly" ? "yearly" : "monthly"),
									className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${d === "yearly" ? "bg-teal-600" : "bg-gray-300"}`,
									children: /* @__PURE__ */ t("span", { className: `inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${d === "yearly" ? "translate-x-6" : "translate-x-1"}` })
								}),
								/* @__PURE__ */ t("span", {
									className: `ml-3 ${d === "yearly" ? "text-gray-900 font-medium" : "text-gray-600"}`,
									children: "Yearly"
								}),
								d === "yearly" && /* @__PURE__ */ t("span", {
									className: "ml-2 bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium",
									children: "Save 17%"
								})
							]
						})
					]
				}),
				/* @__PURE__ */ t("div", {
					className: "grid grid-cols-1 md:grid-cols-3 gap-8 mb-16",
					children: bn.map((e) => /* @__PURE__ */ t(Sn, {
						plan: e,
						billingPeriod: d,
						loading: i,
						onSubscribe: p
					}, e.id))
				}),
				/* @__PURE__ */ n("div", {
					className: "mb-16",
					children: [/* @__PURE__ */ t("h2", {
						className: "text-3xl font-bold text-gray-900 text-center mb-12",
						children: "What Makes Our AI Special"
					}), /* @__PURE__ */ t("div", {
						className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8",
						children: wn.map((e, n) => /* @__PURE__ */ t(xn, { ...e }, n))
					})]
				}),
				/* @__PURE__ */ n("div", {
					className: "bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 md:p-12 text-center text-white mb-16",
					children: [
						/* @__PURE__ */ t(ne, { className: "h-12 w-12 mx-auto mb-4" }),
						/* @__PURE__ */ t("h2", {
							className: "text-3xl font-bold mb-4",
							children: "Need Custom AI Solutions?"
						}),
						/* @__PURE__ */ t("p", {
							className: "text-xl text-purple-100 mb-8 max-w-2xl mx-auto",
							children: "For large organizations requiring custom AI training, dedicated infrastructure, or specialized features, we offer tailored enterprise solutions."
						}),
						/* @__PURE__ */ n("div", {
							className: "flex flex-col sm:flex-row gap-4 justify-center",
							children: [/* @__PURE__ */ t("a", {
								href: "mailto:enterprise@custodio.ai",
								className: "inline-flex items-center justify-center px-8 py-4 bg-white text-purple-600 font-medium rounded-md hover:bg-gray-100 transition-colors text-lg",
								children: "Contact Enterprise Sales"
							}), /* @__PURE__ */ t("a", {
								href: "tel:+918770693644",
								className: "inline-flex items-center justify-center px-8 py-4 bg-transparent text-white font-medium rounded-md border-2 border-white hover:bg-white hover:text-purple-600 transition-colors text-lg",
								children: "Schedule Demo"
							})]
						})
					]
				}),
				/* @__PURE__ */ n("div", {
					className: "mb-16",
					children: [/* @__PURE__ */ t("h2", {
						className: "text-3xl font-bold text-gray-900 text-center mb-12",
						children: "Pricing FAQ"
					}), /* @__PURE__ */ t("div", {
						className: "max-w-3xl mx-auto",
						children: /* @__PURE__ */ t("div", {
							className: "bg-white rounded-xl shadow-md p-8",
							children: Tn.map((e, n) => /* @__PURE__ */ t(Cn, { ...e }, n))
						})
					})]
				}),
				/* @__PURE__ */ n("div", {
					className: "text-center",
					children: [/* @__PURE__ */ t("h2", {
						className: "text-3xl font-bold text-gray-900 mb-4",
						children: "Ready to Transform Your Document Management?"
					}), /* @__PURE__ */ t("p", {
						className: "text-xl text-gray-600 mb-8 max-w-2xl mx-auto",
						children: "Start with our free plan and experience the power of AI-driven organization."
					})]
				})
			]
		})
	});
}, Dn = "\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n", On = ({ size: r = "medium", className: i = "" }) => /* @__PURE__ */ n(e, { children: [/* @__PURE__ */ t("style", { children: Dn }), /* @__PURE__ */ t("div", {
	className: `flex items-center justify-center ${i}`,
	children: /* @__PURE__ */ t("div", {
		className: `${{
			small: "w-4 h-4",
			medium: "w-8 h-8",
			large: "w-12 h-12"
		}[r]} border-2 rounded-full border-teal-600`,
		style: {
			borderColor: "rgb(13 148 136) transparent rgb(13 148 136) rgb(13 148 136)",
			animation: "spin 1s linear infinite"
		},
		role: "status",
		"aria-label": "loading"
	})
})] }), kn = ({ children: e }) => /* @__PURE__ */ t("div", {
	className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8",
	children: /* @__PURE__ */ t(a, {
		fallback: /* @__PURE__ */ t(On, {}),
		children: e
	})
});
//#endregion
//#region src/lib/EmptyState.tsx
function An({ icon: e, title: r, description: i, action: a, className: o = "" }) {
	return /* @__PURE__ */ n("div", {
		className: `flex flex-col items-center justify-center py-16 px-4 text-center ${o}`,
		children: [
			e && /* @__PURE__ */ t("div", {
				className: "mb-4 text-secondary-300",
				children: e
			}),
			/* @__PURE__ */ t("h3", {
				className: "text-lg font-semibold text-secondary-700 mb-2",
				children: r
			}),
			i && /* @__PURE__ */ t("p", {
				className: "text-sm text-secondary-500 max-w-sm mb-4",
				children: i
			}),
			a && /* @__PURE__ */ t("div", { children: a })
		]
	});
}
//#endregion
//#region src/lib/ErrorState.tsx
function jn({ message: e = "Something went wrong.", onRetry: r, className: i = "" }) {
	return /* @__PURE__ */ n("div", {
		className: `flex flex-col items-center justify-center py-16 px-4 text-center ${i}`,
		children: [
			/* @__PURE__ */ t(x, { className: "w-10 h-10 text-red-400 mb-4" }),
			/* @__PURE__ */ t("h3", {
				className: "text-base font-semibold text-secondary-700 mb-1",
				children: "Failed to load"
			}),
			/* @__PURE__ */ t("p", {
				className: "text-sm text-secondary-500 max-w-sm mb-4",
				children: e
			}),
			r && /* @__PURE__ */ n("button", {
				onClick: r,
				className: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-primary-600 border border-primary-300 rounded-lg hover:bg-primary-50 transition-colors",
				children: [/* @__PURE__ */ t(T, { className: "w-4 h-4" }), "Try again"]
			})
		]
	});
}
//#endregion
//#region src/lib/Skeleton.tsx
function $({ className: e = "" }) {
	return /* @__PURE__ */ t("div", {
		className: `animate-pulse bg-secondary-200 rounded ${e}`,
		"aria-hidden": "true"
	});
}
function Mn() {
	return /* @__PURE__ */ n("div", {
		className: "bg-white rounded-xl border border-secondary-200 p-4 space-y-3",
		children: [
			/* @__PURE__ */ t($, { className: "h-4 w-3/4" }),
			/* @__PURE__ */ t($, { className: "h-3 w-1/2" }),
			/* @__PURE__ */ t($, { className: "h-3 w-full" }),
			/* @__PURE__ */ t($, { className: "h-3 w-2/3" })
		]
	});
}
function Nn({ count: e = 3 }) {
	return /* @__PURE__ */ t("div", {
		className: "space-y-3",
		children: Array.from({ length: e }, (e, n) => /* @__PURE__ */ t(Mn, {}, n))
	});
}
function Pn({ rows: e = 5 }) {
	return /* @__PURE__ */ n("div", {
		className: "space-y-2",
		children: [/* @__PURE__ */ t($, { className: "h-8 w-full" }), Array.from({ length: e }, (e, n) => /* @__PURE__ */ t($, { className: "h-6 w-full" }, n))]
	});
}
//#endregion
//#region src/lib/PageErrorBoundary.tsx
var Fn = class extends i.Component {
	constructor(e) {
		super(e), this.state = {
			hasError: !1,
			message: ""
		};
	}
	static getDerivedStateFromError(e) {
		return {
			hasError: !0,
			message: e?.message || "An unexpected error occurred."
		};
	}
	componentDidCatch(e, t) {
		console.error("[PageErrorBoundary]", e, t);
	}
	handleRetry = () => {
		this.setState({
			hasError: !1,
			message: ""
		});
	};
	render() {
		return this.state.hasError ? /* @__PURE__ */ t("div", {
			className: "min-h-64 flex items-center justify-center",
			children: /* @__PURE__ */ t(jn, {
				message: this.state.message,
				onRetry: this.handleRetry
			})
		}) : this.props.children;
	}
};
//#endregion
export { l as CustodioAiComponents, An as EmptyState, jn as ErrorState, On as Loading, kn as PageContainer, Fn as PageErrorBoundary, En as PricingPage, $ as Skeleton, Mn as SkeletonCard, Nn as SkeletonList, Pn as SkeletonTable };
